import { variables } from "$lib/env";
import ky from "ky";

const apiUnauthenticated = ky.extend({
    prefixUrl: variables.api_baseurl,
    retry: {
        limit: 0
    }
});

export default apiUnauthenticated;